import React from "react";
import { PostActionButton } from "./PostCard.styles";
import Images from "config/Images";

const SaveAction: React.FC = () => {
  return (
    <PostActionButton>
      <img src={Images.saveIcon} alt="Save" /> Save
    </PostActionButton>
  );
};

export default SaveAction;
